<template>
  <div class="invoices-page">
    <!-- ===== Row 1: KPI Cards ===== -->
    <div class="kpi-row fade-in">
      <div class="kpi-card" v-for="(kpi, i) in invoiceStats" :key="i">
        <div>
          <h4>{{ kpi.title }}</h4>
          <div class="value">{{ kpi.value }}</div>
        </div>
        <i :class="kpi.icon + ' kpi-icon'"></i>
      </div>
    </div>

    <!-- ===== Row 2: Filters ===== -->
    <div class="grid-header fade-in">
      <div class="filters">
        <!-- Search -->
        <div class="search-box">
          <i class="bx bx-search"></i>
          <input
            type="text"
            v-model="searchQuery"
            :placeholder="'Search '+get_mtype()+'...'"
            @input="loadInvoices"
          />
        </div>


        <!-- Document type tabs -->
        <div class="filter-buttons">
          <button
            :class="['filter-btn', activeFilter1 === 'invoices' ? 'active' : '']"
            @click="switchType('invoices')"
          >
            Invoices
          </button>
          <button
            :class="['filter-btn', activeFilter1 === 'estimates' ? 'active' : '']"
            @click="switchType('estimates')"
          >
            Estimates
          </button>
          <button
            :class="['filter-btn', activeFilter1 === 'purchase_order' ? 'active' : '']"
            @click="switchType('purchase_order')"
          >
            Purchase Order
          </button>
          <button
            :class="['filter-btn', activeFilter1 === 'credit_memo' ? 'active' : '']"
            @click="switchType('credit_memo')"
          >
            Credit Memo
          </button>
        </div>

        <!-- Status dropdown -->
        <select v-model="selectedStatus" class="select-theme" @change="loadInvoices">
          <option value="">All Status</option>
          <option value="Sent">Sent</option>
          <option value="Open">Open</option>
          <option value="Draft">Draft</option>
        </select>
      </div>

      <!-- Add new -->
      <div class="add-new-container">
        <button @click="showAddPopup = true" class="btn-primary">
          <i class="bx bx-plus"></i> Add New
        </button>
      </div>
    </div>

   <transition name="fade-slide" v-if="loading">
      <div class="global-loader">
        <div class="loader-spinner"></div>
        <p>Loading...</p>
      </div>
    </transition>

    <div v-else-if="isEmpty" class="empty-placeholder fade-in">
      <i class="bx bx-inbox"></i>
      <h4>No {{ get_mtype() }} found</h4>
      <p>Try adjusting filters or create a new one.</p>
     <button
  class="btn-primary"
  @click="showAddPopup = true"
  style="
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: var(--primary);
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 10px 18px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    height: 42px;
    min-width: 140px;
    line-height: 1;
    transition: all 0.3s ease;
  "
  onmouseover="this.style.background='var(--primary)'"
  onmouseout="this.style.background='var(--primary)'"
>
  <i class="bx bx-plus" style="font-size: 1rem;"></i> Add New
</button>

    </div>

    <div v-else class="website-grid fade-in">
  <div class="website-card" v-for="invoice in filteredInvoices" :key="invoice.id">
    <!-- Header -->
    <div class="website-card-header">
      <h4>
        <i
          :class="{
            'bx bx-file': main_type === 'invoice',
            'bx bx-notepad': main_type === 'estimate',
            'bx bx-cart': main_type === 'purchaseorder',
            'bx bx-credit-card-front': main_type === 'creditmemo',
          }"
        ></i>
        {{ invoice.refNumber }}
      </h4>

      <div class="card-menu">
        <i class="bx bx-dots-vertical-rounded"></i>
        <div class="card-menu-dropdown">
          <button @click="editInvoice(invoice)">
            <i class="bx bx-edit"></i> Edit
          </button>
          <button @click="confirmDelete(invoice)">
            <i class="bx bx-trash"></i> Delete
          </button>
          <button @click="downloadInvoice(invoice)">
            <i class="bx bx-download"></i> Download
          </button>
          <button @click="copyLink(invoice.id)">
            <i class="bx bx-copy"></i> Copy Link
          </button>
        </div>
      </div>
    </div>

    <!-- Body -->
    <div class="website-card-body">
      <div class="invoice-meta">
        <div class="meta-item">
          <i class="bx bx-user"></i> {{ invoice.customer }}
        </div>
        <div class="meta-item">
          <i class="bx bx-calendar"></i> {{ invoice.date }}
        </div>
      </div>

      <div class="invoice-details">
        <div class="detail-item">
          <strong>Amount:</strong>
          <span>${{ invoice.amount }}</span>
        </div>

        <!-- Status (common to all) -->
        <div class="detail-item">
          <strong>Status:</strong>
          <span class="status" :class="invoice.status.toLowerCase()">
            <i :class="invoice.statusIcon"></i> {{ invoice.status }}
          </span>
        </div>

        <!-- Payment (only for invoice type) -->
        <div
          class="detail-item"
          v-if="main_type === 'invoice'"
        >
          <strong>Payment:</strong>
          <span class="payment" :class="invoice.paymentStatus.toLowerCase()">
            <i :class="invoice.paymentIcon"></i> {{ invoice.paymentStatus }}
          </span>
        </div>

        <div class="detail-item">
          <strong>Created:</strong>
          <span>{{ invoice.createdAt }}</span>
        </div>
      </div>

      <!-- Payment buttons (Invoice only) -->
      <div
        class="add-payment"
        v-if="main_type === 'invoice'"
      >
        <button v-if="!invoice.paymentStatus==='Paid'" class="mini-btn" @click="openPaymentPopup(invoice)">
          <i class="bx bx-credit-card"></i> Add Payment
        </button>
        <button class="mini-btn secondary" @click="openViewPaymentsPopup(invoice)">
          <i class="bx bx-show"></i> View Payments
        </button>
      </div>

      <!-- For Credit Memo -->
      <div
        class="creditmemo-extra"
        v-else-if="main_type === 'creditmemo'"
      >
        <p class="text-note">
          <i class="bx bx-receipt"></i> Credit applied to invoice or awaiting application.
        </p>
      </div>

      <!-- For Estimate -->
      <div
        class="estimate-extra"
        v-else-if="main_type === 'estimate'"
      >
        <p class="text-note">
          <i class="bx bx-info-circle"></i> Awaiting client approval or conversion to invoice.
        </p>
      </div>

      <!-- For Purchase Order -->
      <div
        class="purchase-extra"
        v-else-if="main_type === 'purchaseorder'"
      >
        <p class="text-note">
          <i class="bx bx-cart"></i> Pending vendor fulfillment or receipt.
        </p>
      </div>
    </div>

    <!-- Footer -->
    <div class="website-card-footer">
      <span class="website-domain">Ref: {{ invoice.refNumber }}</span>
      <div class="website-actions">
         
        <button class="btn-download" @click="downloadInvoice(invoice)">
          <i class="bx bx-download"></i> Download
        </button>
      </div>
    </div>
  </div>
</div>


    <!-- ===== Row 4: Pagination ===== -->
    <div class="pagination fade-in">
      <span>
        Showing {{ pagination.from }}–{{ pagination.to }} of {{ pagination.total }}
      </span>
      <div class="pagination-buttons">
        <button @click="changePage(page_no - 1)" :disabled="page_no <= 0">
          <i class="bx bx-chevron-left"></i>
        </button>
        <button class="active">{{ page_no + 1 }}</button>
        <button
          @click="changePage(page_no + 1)"
          :disabled="pagination.to >= pagination.total"
        >
          <i class="bx bx-chevron-right"></i>
        </button>
      </div>
    </div>

    <!-- ===== Popups ===== -->
    <div
      v-if="showPaymentPopup"
      class="popup-overlay"
      @click.self="closePaymentPopup"
    >
      <div class="popup-card scale-in" style="width: 30rem;">
        <h3><i class="bx bx-credit-card"></i> Add Payment</h3>
        <div class="popup-form">
          <div class="form-group">
            <label>Date</label><input type="date" v-model="paymentForm.date" />
          </div>
          <div class="form-group">
            <label>Payment Method</label>
            <select v-model="paymentForm.method">
              <option value="">Select Method</option>
              <option>Credit Card</option>
              <option>Bank Transfer</option>
              <option>Cash</option>
              <option>UPI</option>
            </select>
          </div>
          <div class="form-group two-cols">
            <div>
              <label>Total</label><input type="number" v-model="paymentForm.total" />
            </div>
            <div>
              <label>Paid</label><input type="number" v-model="paymentForm.amountPaid" />
            </div>
          </div>
          <div class="form-group">
            <label>Due</label><input type="number" v-model="paymentForm.amountDue" />
          </div>
          <div class="form-group">
            <label>Note</label><textarea v-model="paymentForm.note" rows="3"></textarea>
          </div>
        </div>
        <div class="popup-actions">
          <button class="btn-primary" @click="saveInvoicePayment">
  <i class="bx bx-save"></i> Save
</button>
          <button class="btn-secondary" @click="closePaymentPopup">
            <i class="bx bx-x"></i> Cancel
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="showViewPaymentsPopup"
      class="popup-overlay"
      @click.self="closeViewPaymentsPopup"
    >
      <div class="popup-card scale-in">
        <h3><i class="bx bx-list-check"></i> Payment History</h3>
        <div class="table-wrapper">
          <table class="popup-table">
            <thead>
              <tr>
                <th>Ref</th><th>Customer</th>
                <th>Amount</th><th>Status</th><th>Created</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="p in previousPayments" :key="p.ref">
                <td>{{ p.ref }}</td><td>{{ p.customer }}</td>
                <td>{{ p.amount }}</td>
                <td>
                  <span class="payment-status" :class="p.status.toLowerCase()">
                    <i
                      :class="
                        p.status === 'Paid'
                          ? 'bx bx-check-circle'
                          : 'bx bx-time-five'
                      "
                    ></i>
                    {{ p.status }}
                  </span>
                </td>
                <td>{{ p.createdAt }}</td>
                <td>
  <button class="mini-btn danger" @click="deleteInvoicePay(p.pay_id)">
    <i class="bx bx-trash"></i>
  </button>
</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="popup-actions">
          <button class="btn-secondary" @click="closeViewPaymentsPopup">
            <i class="bx bx-x"></i> Close
          </button>
        </div>
      </div>
    </div>

    <!-- ===== Add-New Popup (Modal) ===== -->
    <transition name="fade-scale">
      <div v-if="showAddPopup" class="modal-overlay" @click.self="closePopup">
        <div class="modal-card">
          <div class="modal-options">
            <button @click="navigateTo('add_invoice')" class="option-btn">
              <i class="bx bx-file"></i> New Invoice
            </button>
            <button @click="navigateTo('add_estimate')" class="option-btn">
              <i class="bx bx-notepad"></i> New Estimate
            </button>
            <button @click="navigateTo('add_purchase_order')" class="option-btn">
              <i class="bx bx-cart"></i> New Purchase Order
            </button>
            <button @click="navigateTo('add_credit_memo')" class="option-btn">
              <i class="bx bx-credit-card-front"></i> New Credit Memo
            </button>
          </div>
        </div>
      </div>
    </transition>
    <ConfirmDialog
  :show="showConfirm"
  :title="confirmTitle"
  :message="confirmMessage"
  @cancel="showConfirm = false"
  @confirmAction="handleConfirm"
/>

    <br><br><br><br>
  </div>
</template>


<script scoped>
import { ref, computed, onMounted,nextTick,watch } from "vue";
import { useToast } from "vue-toastification";
import ConfirmDialog from "@/comps/ConfirmDialog.vue";
import html2pdf from "html2pdf.js";

import {
  getInvoices,
  getInvoiceReport,
  deleteInvoice,
  updateInvoicePaymentStatus,
} from "@/apis/invoiceapis";
import {
  mainBaseUrl
} from "@/apis/appconst";
import { createPayment, listPayments, deletePayment } from "@/apis/paymentapis";
const selectedInvoice = ref(null);



export default {
  name: "InvoicesPage",
  components: {
    ConfirmDialog
  },
  setup() {
    const showConfirm = ref(false);
const confirmTitle = ref("");
const confirmMessage = ref("");
let confirmCallback = () => {};
const openConfirm = async(title, message, onConfirm) => {
  confirmTitle.value = title;
  confirmMessage.value = message;
  confirmCallback = onConfirm;
  showConfirm.value = true;
  await nextTick();
};
const handleConfirm = async() => {
  showConfirm.value = false;
  if (typeof confirmCallback === "function") {
    confirmCallback();
  }
  await nextTick();
};
    const page_no = ref(0);
    const pagination = ref({ total: 0, from: 0, to: 0 });
    const toast = useToast();
    const report = ref({});

    // === Core State ===
    const main_type = ref("invoice"); // default tab: Invoices
    const invoices = ref([]);
    const loading = ref(false);
    const isEmpty = ref(false);
    const showAddPopup = ref(false);
    const showPaymentPopup = ref(false);
    const showViewPaymentsPopup = ref(false);
    const searchQuery = ref("");
    const selectedStatus = ref("");
    const activeFilter = ref("all");
    const activeFilter1 = ref("invoices");
    const userData = JSON.parse(sessionStorage.getItem("ldata")) || {};
    const userId = userData?.user_id || "";

   

    // === Payment Form ===
    const paymentForm = ref({
      date: "",
      method: "",
      total: "",
      amountPaid: "",
      amountDue: "",
      note: "",
    });

    const previousPayments = ref([
      {
        ref: "#PAY-001",
        customer: "John Doe",
        contact: "+1 234 567 890",
        amount: "$560",
        status: "Paid",
        createdAt: "30 Oct 2025",
      },
      {
        ref: "#PAY-002",
        customer: "Mike Ross",
        contact: "+1 234 567 890",
        amount: "$230",
        status: "Pending",
        createdAt: "02 Nov 2025",
      },
    ]);

    const invoiceStats = computed(() => {
  switch (main_type.value) {
    case "invoice":
      return [
        { title: "Total Invoices", value: report.value.total || 0, icon: "bx bx-file" },
        { title: "Paid", value: report.value.paid || 0, icon: "bx bx-check-circle" },
        { title: "Unpaid", value: report.value.unpaid || 0, icon: "bx bx-x-circle" },
        { title: "Pending", value: report.value.pending || 0, icon: "bx bx-time-five" },
      ];

    case "estimate":
      return [
        { title: "Total Estimates", value: report.value.total || 0, icon: "bx bx-notepad" },
        { title: "Approved", value: report.value.approved || 0, icon: "bx bx-check" },
        { title: "Rejected", value: report.value.rejected || 0, icon: "bx bx-x" },
        { title: "Sent", value: report.value.sent || 0, icon: "bx bx-time" },
      ];

    case "purchaseorder":
      return [
        { title: "Total POs", value: report.value.total || 0, icon: "bx bx-cart" },
        { title: "Received", value: report.value.received || 0, icon: "bx bx-package" },
        { title: "Pending", value: report.value.pending || 0, icon: "bx bx-time-five" },
        { title: "Draft", value: report.value.draft || 0, icon: "bx bx-block" },
      ];

    case "creditmemo":
      return [
        { title: "Total Credits", value: report.value.total || 0, icon: "bx bx-credit-card" },
        { title: "Applied", value: report.value.applied || 0, icon: "bx bx-check-circle" },
        { title: "Pending", value: report.value.pending || 0, icon: "bx bx-time" },
        { title: "Draft", value: report.value.draft || 0, icon: "bx bx-x" },
      ];

    default:
      return [];
  }
});




    // === Load Invoices ===
    const loadInvoices = async () => {
      try {
        loading.value = true;
        isEmpty.value = false;

        const res = await getInvoices(
          main_type.value,
          userId,
          page_no.value,
          selectedStatus.value,
          "",
          searchQuery.value
        );

        if (res?.status && res?.records?.length > 0) {
          invoices.value = res.records.map((item) => ({
            id:
              item.invoice_id ||
              item.estimate_id ||
              item.po_id ||
              item.credit_id,
            refNumber:
              item.invoice_number ||
              item.estimate_number ||
              item.po_number ||
              item.credit_number ||
              "—",
            customer:item.fname+" "+item.lname,
            amount:
              item.invoice_final_total ||
              item.estimate_final_total ||
              item.po_final_total ||
              item.credit_final_total ||
              0,
            status:
              item.invoice_status ||
              item.estimate_status ||
              item.po_status ||
              item.credit_status ||
              "Pending",
            paymentStatus:
              item.invoice_pay_status ||
              item.estimate_payment_status ||
              item.po_payment_status ||
              item.credit_payment_status ||
              "Unpaid",
            date:
              item.invoice_date ||
              item.estimate_date ||
              item.po_order_date ||
              item.credit_date ||
              "—",
            createdAt:
              item.invoice_created_at ||
              item.estimate_created_at ||
              item.po_created_at ||
              item.credit_created_at
                ? new Date(
                    item.invoice_created_at ||
                      item.estimate_created_at ||
                      item.po_created_at ||
                      item.credit_created_at
                  ).toLocaleDateString()
                : "—",
            statusIcon:
              item.invoice_status === "Sent"
                ? "bx bx-paper-plane"
                : "bx bx-envelope-open",
            paymentIcon:
              item.invoice_pay_status === "Paid"
                ? "bx bx-check-circle"
                : "bx bx-x-circle",
          }));

          pagination.value.total = res.total1 || invoices.value.length;
          pagination.value.from = page_no.value * 10 + 1;
          pagination.value.to = Math.min(
            pagination.value.from + invoices.value.length - 1,
            pagination.value.total
          );
        } else {
          invoices.value = [];
          isEmpty.value = true;
          pagination.value.total = 0;
          pagination.value.from = 0;
          pagination.value.to = 0;
        }
      } catch (err) {
        console.error("loadInvoices error:", err);

      } finally {
        loading.value = false;
      }
    };

    // === Load KPI Stats ===
   const loadInvoiceReport = async () => {
  try {
    const res = await getInvoiceReport(main_type.value, userId);
    if (res?.status) {
      report.value = res;
    } else {
      report.value = {};
    }
  } catch (err) {
    console.error("loadInvoiceReport error:", err);
  }
};


    // === Delete Record ===
    const confirmDelete = async (invoice) => {
      openConfirm(
          "Delete Confirmation",
          `Are you sure you want to delete ${invoice.refNumber}?`,
          async () => {
            const idField = getIdField(main_type.value);
            try {
              const res = await deleteInvoice(main_type.value, idField, invoice.id);
              if (res?.status) {
                toast.success(res.success || "Deleted successfully!");
                await Promise.all([loadInvoices(), loadInvoiceReport()]);
              } else {
                toast.error("Delete failed.");
              }
            } catch (err) {
              console.error("Delete error:", err);
              toast.error("Something went wrong while deleting.");
            }
          }
        );

    };

    // === Update Payment Status ===
    const updatePaymentStatus = async (invoice, status) => {
      try {
        const res = await updateInvoicePaymentStatus(invoice.id, status);
        if (res?.status) {
          toast.success(res.success || "Payment status updated!");
          await loadInvoices();
        } else {
          toast.error("Failed to update payment.");
        }
      } catch (err) {
        console.error("updatePaymentStatus error:", err);
        toast.error("Something went wrong.");
      }
    };

    // === Helpers ===
    const getIdField = (type) => {
      switch (type) {
        case "estimate":
          return "estimate_id";
        case "purchaseorder":
          return "po_id";
        case "creditmemo":
          return "credit_id";
        default:
          return "invoice_id";
      }
    };

    // === Switch Tabs ===
    const switchType = async (type) => {
      if(type==="purchase_order"){
          activeFilter1.value = "purchase_order";
          main_type.value = "purchaseorder";
        }
        else  if(type==="invoices"){
          activeFilter1.value = "invoices";
          main_type.value = "invoice";
        }
        else  if(type==="estimates"){
          activeFilter1.value = "estimates";
          main_type.value = "estimate";
        }
         else  if(type==="credit_memo"){
          activeFilter1.value = "credit_memo";
          main_type.value = "creditmemo";
        }
      page_no.value = 0;
      await Promise.all([loadInvoices(), loadInvoiceReport()]);
    };

    // === Pagination ===
    const changePage = async (page) => {
      if (page < 0) return;
      page_no.value = page;
      await loadInvoices();
    };

   watch(
  () => paymentForm.value.amountPaid,
  (v) => {
    const total = Number(paymentForm.value.total || 0);
    paymentForm.value.amountDue = total - Number(v || 0);
  }
);


const saving = ref(false);

const saveInvoicePayment = async () => {

  if (!selectedInvoice.value) {
    toast.error("No invoice selected");
    return;
  }

  if (!paymentForm.value.amountDue || paymentForm.value.amountDue  <= 0) {
    toast.error("Enter valid amount");
    return;
  }

  saving.value = true;

  try {
    const payload = {
      pay_user: userId,
      pay_amt: paymentForm.value.amountDue,
      pay_for: "Invoice Payment",
      pay_type: paymentForm.value.method,
      pay_invoice: selectedInvoice.value.id,
      pay_invoice_type: main_type.value,
      pay_desc: paymentForm.value.note,
    };


    const res = await createPayment(payload);

    if (!res.status) {
      toast.error(res.success || "Failed to save");
      return;
    }

    toast.success("Payment Added");

    showPaymentPopup.value = false;

    await loadInvoices();
    await loadInvoiceReport();

  } catch (e) {
    console.error(e);
    toast.error("Server error");
  }

  saving.value = false;
};

    // === UI Handlers ===
    const closePopup = () => (showAddPopup.value = false);
   const openPaymentPopup = async (invoice) => {
  selectedInvoice.value = invoice;

  // 🔹 1) Get previous payments for this invoice
  const res = await listPayments(userId, invoice.id, "", 0);

  let prevPaid = 0;

  if (res?.status && Array.isArray(res.records)) {
    prevPaid = res.records.reduce((sum, p) => sum + Number(p.pay_amt || 0), 0);
  }

  // 🔹 2) Calculate due amount
  const due = Number(invoice.amount) - prevPaid;

  // 🔹 3) Assign form values
  paymentForm.value = {
    date: new Date().toISOString().split("T")[0],
    method: "Cash",
    total: invoice.amount,
    amountPaid: prevPaid,     // ← total of previous payments
    amountDue: due < 0 ? 0 : due,  // ← auto calc
    note: "",
  };

  showPaymentPopup.value = true;
};


    const closePaymentPopup = () => (showPaymentPopup.value = false);
    const openViewPaymentsPopup = async (invoice) => {
  selectedInvoice.value = invoice;

  const res = await listPayments(userId, invoice.id, "", 0);

  if (res?.status) {
    previousPayments.value = res.records.map((p) => ({
      pay_id: p.pay_id,
      ref: "#PAY-" + p.pay_id,
      customer: invoice.customer,
      amount: p.pay_amt,
      status: "Paid",
      createdAt: new Date(p.pay_datetime).toLocaleDateString(),
    }));
  } else {
    previousPayments.value = [];
  }

  showViewPaymentsPopup.value = true;
};

    const closeViewPaymentsPopup = () => (showViewPaymentsPopup.value = false);

    const navigateTo = (path) => {
      showAddPopup.value = false;
      setTimeout(() => {
        window.location.href = "/" + path;
      }, 150);
    };

   const downloadInvoice = (invoice) => {
      if (!invoice.id) {
        console.error("Invalid invoice object");
        return;
      }

      const url = mainBaseUrl+`/invoice/${main_type.value}/${invoice.id}`;

      window.open(url, "_blank");
    };

     const copyLink = (id)=> {
      navigator.clipboard.writeText(mainBaseUrl+`/invoice/${main_type.value}/${id}`);
      const toast = useToast();
      toast.success("Copied!!");
    };

    const editInvoice = (invoice) => {
     
      const pathMap = {
        invoice: "/add_invoice",
        estimate: "/add_estimate",
        purchaseorder: "/add_purchase_order",
        creditmemo: "/add_credit_memo",
      };
      window.location.href = `${pathMap[main_type.value]}?id=${invoice.id}`;
    };

    // === Filtered Computed List ===
    const filteredInvoices = computed(() => {
      return invoices.value.filter(
        (inv) =>
          inv.customer.toLowerCase().includes(searchQuery.value.toLowerCase()) &&
          (!selectedStatus.value || inv.status === selectedStatus.value) &&
          (activeFilter.value === "all" ||
            inv.paymentStatus.toLowerCase() === activeFilter.value)
      );
    });

    // === Lifecycle ===
   onMounted(async () => {
      try {
        
        loading.value = true;

        // 🔹 Get URL parameter (?type=invoice / estimate / po / creditmemo)
        const urlParams = new URLSearchParams(window.location.search);
        const docType = urlParams.get("type");

        // 🔹 Set main_type dynamically (default = "invoice")
        main_type.value = docType || "invoice";
        if(docType==="purchaseorder"){
          activeFilter1.value = "purchase_order";
          main_type.value = "purchaseorder";
        }
        else  if(docType==="invoices"){
          activeFilter1.value = "invoices";
          main_type.value = "invoice";
        }
        else  if(docType==="estimates"){
          activeFilter1.value = "estimates";
          main_type.value = "estimate";
        }
         else  if(docType==="creditmemo"){
          activeFilter1.value = "credit_memo";
          main_type.value = "creditmemo";
        }
        else{
          activeFilter1.value = docType || "invoices";
        }
        await nextTick();
        // 🔹 Load data based on main_type
        await Promise.all([loadInvoices(), loadInvoiceReport()]);
      } catch (error) {
        console.error("onMounted error:", error);
      } finally {
        loading.value = false;
      }
    });

    const deleteInvoicePay = async (pay_id) => {
        openConfirm(
          "Delete Confirmation",
          `Delete this payment?`,
          async () => {
            const res = await deletePayment(pay_id);
            if (res?.status) {
              toast.success("Payment Deleted");

              openViewPaymentsPopup(selectedInvoice.value);
              await loadInvoices();
            } else {
              toast.error("Delete failed");
            }
          }
        );
      };



    return {
      main_type,
      invoices,
      filteredInvoices,
      invoiceStats,
      searchQuery,
      page_no,
      selectedStatus,
      activeFilter,
      activeFilter1,
      showAddPopup,
      showPaymentPopup,
      showViewPaymentsPopup,
      paymentForm,
      previousPayments,
      pagination,
      isEmpty,
      loading,
      selectedInvoice,
      saving,
      showConfirm,
      confirmTitle,
      confirmMessage,
      openConfirm,
      handleConfirm,
      switchType,
      confirmDelete,
      openPaymentPopup,
      saveInvoicePayment,
      deleteInvoicePay,
      updatePaymentStatus,
      closePopup,
      navigateTo,
      closePaymentPopup,
      openViewPaymentsPopup,
      closeViewPaymentsPopup,
      changePage,
      downloadInvoice,
      copyLink,
      editInvoice,
      loadInvoices,
  loadInvoiceReport,
    };
  },
  methods:{
    downloadExternalPagePDF(url){


      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      iframe.src = url;

      document.body.appendChild(iframe);

      iframe.onload = () => {

        const pageBody = iframe.contentDocument.body;

        html2pdf()
          .from(pageBody)
          .set({
            margin: 10,
            filename: "invoice-7.pdf",
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: {
              scale: 2,
              useCORS: true,
              allowTaint: true
            },
            jsPDF: {
              unit: "mm",
              format: "a4",
              orientation: "portrait"
            }
          })
          .save()
          .then(() => {
            document.body.removeChild(iframe);
          });

      };

    }
    ,
   get_mtype() {
  switch (this.main_type) {
    case "invoice":
      return "Invoice";

    case "estimate":
      return "Estimate";

    case "purchaseorder":
      return "Purchase Order";

    case "creditmemo":
      return "Credit Memo";

    default:
      return "Invoice";
  }
}

  }
};
</script>


<style scoped>
/* ===== Loader Overlay ===== */

/* === Copy Button === */
.btn-copy {
  background: var(--primary);
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all 0.3s ease;
}
.btn-copy:hover {
  background: #1e3a8a;
  transform: translateY(-1px);
}

.loader-overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 1rem;
  color: var(--text);
}
.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #d1d5db;
  border-top: 4px solid var(--primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 0.8rem;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ===== Empty Placeholder ===== */
.empty-placeholder {
  text-align: center;
  padding: 4rem 1rem;
  color: var(--muted);
}
.empty-placeholder i {
  font-size: 3rem;
  color: var(--border);
}
.empty-placeholder h4 {
  margin-top: 0.8rem;
  color: var(--text);
  font-weight: 600;
}
.empty-placeholder p {
  font-size: 0.9rem;
  margin-bottom: 1rem;
  color: var(--muted);
}

.fade-in { animation: fadeInUp 0.6s ease forwards; opacity: 0; transform: translateY(10px); }
@keyframes fadeInUp { to { opacity: 1; transform: translateY(0); } }

/* Filters */
.filters { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.filter-buttons { display: flex; gap: 6px; }
.filter-btn { border: none; background: #f3f4f6; color: var(--text); padding: 6px 12px; border-radius: 6px; font-size: 13px; cursor: pointer; transition: 0.25s; }
.filter-btn.active, .filter-btn:hover { background: var(--primary); color: #fff; }
.select-theme { padding: 8px 12px; border: 1px solid var(--border); border-radius: 8px; font-size: 13px; }

/* Card Details */
.invoice-meta { display: flex; justify-content: space-between; color: var(--muted); font-size: 13px; margin-bottom: 6px; }
.invoice-details { font-size: 13px; display: grid; grid-template-columns: repeat(2, 1fr); gap: 6px 12px; }

.status, .payment { padding: 4px 10px; border-radius: 6px; font-weight: 600; font-size: 12px; display: inline-flex; align-items: center; gap: 6px; }
.status.sent { background: #e0f2fe; color: #0369a1; }
.status.open { background: #fef3c7; color: #92400e; }
.status.draft { background: #f3f4f6; color: #374151; }
.payment.paid { background: #dcfce7; color: #166534; }
.payment.unpaid { background: #fee2e2; color: #991b1b; }

/* Buttons */
.mini-btn { background: var(--primary); color: #fff; border: none; padding: 6px 10px; border-radius: 6px; font-size: 12px; cursor: pointer; transition: 0.3s; margin-right: 5px; }
.mini-btn.secondary { background: #f3f4f6; color: var(--text); }
.mini-btn:hover { transform: translateY(-1px); }

/* Popup Overlay */
.popup-overlay { position: fixed; inset: 0;
  display: flex; 
  justify-content: center; align-items: center; z-index: 2000; backdrop-filter: blur(3px); }
.popup-card { background: #fff; border-radius: 14px; padding: 24px;  max-width: 95%; box-shadow: 0 10px 40px rgba(0,0,0,0.2); animation: scaleIn 0.3s ease forwards; }
@keyframes scaleIn { from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1); } }
.popup-form .form-group { margin-bottom: 14px; display: flex; flex-direction: column; }
.popup-form label { font-size: 13px; color: var(--muted); margin-bottom: 4px; }
.popup-form input, .popup-form select, .popup-form textarea { border: 1px solid var(--border); border-radius: 8px; padding: 8px 10px; font-size: 13px; transition: all 0.25s ease; }
.popup-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 10px; }

/* Payment Table */
.table-wrapper { overflow-y: auto; margin-bottom: 12px; }
.popup-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.popup-table th, .popup-table td { padding: 8px 10px; border-bottom: 1px solid var(--border); }
.popup-table th { background: #f9fafb; font-weight: 600; color: var(--muted); }
.payment-status { padding: 4px 8px; border-radius: 6px; font-size: 12px; font-weight: 600; display: inline-flex; align-items: center; gap: 5px; }
.payment-status.paid { background: #dcfce7; color: #166534; }
.payment-status.pending { background: #fef3c7; color: #92400e; }

/* Pagination */
.pagination { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px; margin-top: 20px; }
.pagination-buttons { display: flex; align-items: center; gap: 6px; }
.pagination-buttons button { border: none; background: #f3f4f6; color: var(--text); padding: 6px 10px; border-radius: 6px; cursor: pointer; transition: 0.3s; }
.pagination-buttons button.active, .pagination-buttons button:hover { background: var(--primary); color: #fff; }

/* === Card Menu (⋮ Actions Dropdown) === */
.card-menu {
  position: relative;
}
.card-menu i {
  cursor: pointer;
  font-size: 1.3rem;
  color: var(--text);
  transition: color 0.25s ease;
}
.card-menu i:hover {
  color: var(--primary);
}

/* Dropdown Container */
.card-menu-dropdown {
  position: absolute;
  right: 0;
  top: 1.8rem;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  display: none;
  flex-direction: column;
  min-width: 140px;
  z-index: 100;
  animation: fadeDropdown 0.2s ease forwards;
}

/* Show on Hover */
.card-menu:hover .card-menu-dropdown {
  display: flex;
}

/* Dropdown Buttons */
.card-menu-dropdown button {
  border: none;
  background: none;
  text-align: left;
  padding: 8px 12px;
  font-size: 13px;
  cursor: pointer;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
}
.card-menu-dropdown button:hover {
  background: #f3f4f6;
  color: var(--primary);
}
.card-menu-dropdown i {
  font-size: 1rem;
  color: var(--muted);
}

/* Dropdown Fade Animation */
@keyframes fadeDropdown {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* === Footer Download Button === */
.website-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px solid var(--border);
}

.btn-download {
  background: #f3f4f6;
  color: var(--text);
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
  font-weight: 500;
}

.btn-download:hover {
  background: var(--primary);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 3px 10px rgba(17, 24, 39, 0.2);
}

.btn-download i {
  font-size: 1rem;
}

/* === Card Hover Animation (Optional for polish) === */
.website-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.website-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(17, 24, 39, 0.08);
}
/* === Popup Header Close Icon === */
.popup-card {
  position: relative;
}

/* Optional top-right close (X) icon */
.popup-close {
  position: absolute;
  top: 14px;
  right: 14px;
  background: transparent;
  border: none;
  color: var(--muted);
  font-size: 1.3rem;
  cursor: pointer;
  transition: all 0.25s ease;
}
.popup-close:hover {
  color: var(--primary);
  transform: rotate(90deg);
}

/* === Popup Footer Buttons (Save / Cancel) === */
.popup-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

/* Primary Button (Save) */
.popup-actions .btn-primary {
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.popup-actions .btn-primary:hover {
  background: var(--primary-dark);
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(17, 24, 39, 0.15);
}

/* Secondary Button (Cancel / Close) */
.popup-actions .btn-secondary {
  background: #f3f4f6;
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.popup-actions .btn-secondary:hover {
  background: #e5e7eb;
  border-color: #d1d5db;
  transform: translateY(-1px);
}

/* === Popup Button Animations === */
.popup-actions button i {
  font-size: 1rem;
  transition: transform 0.3s ease;
}
.popup-actions button:hover i {
  transform: translateX(2px);
}

/* === Responsive Fix for Mobile === */
@media (max-width: 480px) {
  .popup-actions {
    flex-direction: column;
    justify-content: center;
  }
  .popup-actions button {
    width: 100%;
    text-align: center;
  }
}

/* === Invoice Meta === */
.invoice-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--muted);
  font-size: 13px;
  margin-bottom: 12px;
  gap: 12px;
  flex-wrap: wrap;
}
.invoice-meta .meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
}
.invoice-meta i {
  color: var(--primary);
  font-size: 1rem;
}

/* === Invoice Details === */
.invoice-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(150px, 1fr));
  gap: 8px 16px;
  font-size: 13px;
  color: var(--text);
  margin-bottom: 12px;
}
.invoice-details .detail-item {
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 1.4;
}
.invoice-details strong {
  font-weight: 600;
  color: var(--text-dark);
}
.status,
.payment {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
}

/* === Quick Action Buttons === */
.add-payment {
  display: flex;
  gap: 10px;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 8px;
}
.mini-btn {
  background: var(--primary);
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.mini-btn:hover {
  background: var(--primary-dark);
  transform: translateY(-1px);
}
.mini-btn.secondary {
  background: #f3f4f6;
  color: var(--text);
}
.mini-btn.secondary:hover {
  background: #e5e7eb;
}

/* === Icon inside buttons === */
.mini-btn i {
  font-size: 1rem;
}

/* === Responsive === */
@media (max-width: 768px) {
  .invoice-details {
    grid-template-columns: 1fr;
  }
  .invoice-meta {
    flex-direction: column;
    align-items: flex-start;
  }
}
/* === Invoice Grid Layout === */
.website-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 💎 3 cards in a row */
  gap: 24px;
  align-items: stretch;
  margin-top: 20px;
}

/* Each Card */
.website-card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.website-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 18px rgba(17, 24, 39, 0.08);
}

/* === Responsive Adjustments === */
@media (max-width: 1200px) {
  .website-grid {
    grid-template-columns: repeat(2, 1fr); /* 2 cards in a row on medium screens */
  }
}

@media (max-width: 768px) {
  .website-grid {
    grid-template-columns: 1fr; /* 1 card per row on mobile */
  }
}

/* === Card Spacing Inside === */
.website-card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}
/* === Trigger Button === */
.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 10px 18px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}
.btn-primary:hover {
  background: var(--primary-dark);
  transform: translateY(-1px);
}

.modal-overlay {
  margin-top: -30;
  position: fixed;
  inset: 0;
  /* background: rgba(17, 24, 39, 0.6); */
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(3px);
  z-index: 5000;
}

/* === Popup Card === */
.modal-card {
  background: #fff;
  border-radius: 16px;
  padding: 1.8rem;
  width: 420px;
  max-width: 90%;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
  animation: popIn 0.3s ease;
}

/* Header */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.2rem;
}

.modal-header h3 {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.2rem;
  color: #111827;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.4rem;
  color: var(--muted);
  cursor: pointer;
  transition: all 0.3s ease;
}
.close-btn:hover {
  color: var(--primary);
  transform: rotate(90deg);
}

/* === Options === */
.modal-options {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.option-btn {
  background: #f9fafb;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 0.9rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text);
  cursor: pointer;
  transition: all 0.25s ease;
}
.option-btn:hover {
  background: var(--primary);
  color: #fff;
  transform: translateY(-2px);
}
.option-btn i {
  font-size: 1.2rem;
}

/* === Animations === */
@keyframes popIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.25s ease;
}
.fade-scale-enter-from,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

/* === Two Columns Form Layout === */
.form-group.two-cols {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  align-items: center;
}

/* Ensures inputs look balanced */
.form-group.two-cols > div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Labels inside two-cols should align neatly */
.form-group.two-cols label {
  font-size: 13px;
  color: var(--muted);
  font-weight: 500;
}

/* Responsive behavior for small screens */
@media (max-width: 600px) {
  .form-group.two-cols {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}
/* === 📱 MOBILE RESPONSIVE PATCH FOR INVOICES PAGE === */
@media (max-width: 768px) {
  /* KPI Cards Stack */
  .kpi-row {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 12px !important;
  }
  .kpi-card {
    flex: 1 1 100% !important;
    text-align: left !important;
  }

  /* Filters stack neatly */
  .filters {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 0.8rem !important;
  }

  .filter-buttons {
    flex-wrap: wrap !important;
    justify-content: flex-start !important;
    gap: 8px !important;
  }

  .filter-btn {
    flex: 1 1 45% !important;
    text-align: center !important;
  }

  .select-theme {
    width: 100% !important;
  }

  /* Add button centered */
  .add-new-container {
    width: 100% !important;
    display: flex !important;
    justify-content: center !important;
  }

  .btn-primary {
    width: 100% !important;
    justify-content: center !important;
  }

  /* Invoice Cards Layout */
  .website-grid {
    grid-template-columns: 1fr !important;
    gap: 16px !important;
  }

  .website-card {
    padding: 1rem !important;
  }

  /* Invoice Details Stack */
  .invoice-meta {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 6px !important;
  }
  .invoice-details {
    grid-template-columns: 1fr !important;
    gap: 8px !important;
  }

  /* Buttons and Mini actions */
  .add-payment {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 8px !important;
  }
  .mini-btn,
  .mini-btn.secondary {
    width: 100% !important;
    justify-content: center !important;
  }

  /* Popup Adjustments */
  .popup-card {
    width: 95% !important;
    padding: 1.2rem !important;
  }

  .popup-form input,
  .popup-form select,
  .popup-form textarea {
    font-size: 0.9rem !important;
  }

  .popup-actions {
    flex-direction: column !important;
    gap: 10px !important;
  }

  .popup-actions button {
    width: 100% !important;
    text-align: center !important;
  }

  /* Table Scroll on Small Devices */
  .table-wrapper {
    overflow-x: auto !important;
  }
  .popup-table {
    min-width: 600px !important;
  }

  /* Modal Fix */
  .modal-card {
    width: 90% !important;
    padding: 1.2rem !important;
  }

  .option-btn {
    font-size: 0.9rem !important;
    padding: 0.8rem !important;
  }
}

/* === 📱 EXTRA SMALL DEVICES (≤480px) === */
@media (max-width: 480px) {
  .kpi-row {
    grid-template-columns: 1fr !important;
  }

  .filters {
    gap: 0.6rem !important;
  }

  .filter-btn {
    flex: 1 1 100% !important;
    font-size: 0.85rem !important;
  }

  .btn-primary {
    font-size: 0.9rem !important;
    padding: 0.7rem 1rem !important;
  }

  .website-card {
    padding: 0.8rem !important;
  }

  .popup-card {
    width: 90% !important;
    border-radius: 0.8rem !important;
    padding: 1rem !important;
  }

  .option-btn {
    font-size: 0.85rem !important;
    padding: 0.7rem 0.8rem !important;
  }
}

</style>

